import HttpUtils from '@/framework/HttpUtils';
import { handelPromise } from '@/utils';
//获取游戏列表
export const getConversations = async (): Promise<MessageConversation[]> => {
    return await handelPromise<any>(HttpUtils.Get('/conversations'));
};

export const getMessages = async (conversationId: string): Promise<ChatMessage[]> => {
    return await handelPromise<any>(HttpUtils.Get('/conversations/message?conversationId=' + conversationId));
};

export const getTodayAiPoints = async (): Promise<TokenRechargeRecord> => {
    return await handelPromise<any>(HttpUtils.Get('/ai-points/today-ai-point'));
};
